import * as React from "react";
const SvgEditWhite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="M18.946 12.109H14.77c-1.67 0-2.505 0-3.143.325a3 3 0 0 0-1.303 1.303C10 14.374 10 15.21 10 16.88v8.349c0 1.67 0 2.505.325 3.143a3 3 0 0 0 1.303 1.303c.638.325 1.473.325 3.143.325h8.35c1.67 0 2.505 0 3.142-.325a3 3 0 0 0 1.303-1.303c.326-.638.326-1.473.326-3.143v-4.175m-11.928 2.982h1.664c.486 0 .73 0 .958-.055q.306-.073.575-.238c.2-.123.372-.295.716-.638l9.505-9.505a2.108 2.108 0 1 0-2.982-2.982l-9.505 9.505c-.343.343-.515.515-.638.716q-.165.269-.238.575c-.055.228-.055.471-.055.958z"
    />
  </svg>
);
export default SvgEditWhite;
